<div class="linetitle-b lessmb"></div>
<div class="basicrow order-sumary">
  <div class="alltotals-c items" *ngFor="let item of this.itemsCart.taxes">
    <div class="alltotals-txt items1">
      {{item.taxDesc | uppercase}}
    </div>
    <div class="alltotals-numb roboto-b f-red items1">
      {{item.taxAmt | currency }}
    </div>
  </div>
  <div class="alltotals-c items">
    <div class="alltotals-txt items1">
      TOTAL CARGOS ESTATALES Y FEDERALES
    </div>
    <div class="alltotals-numb roboto-b f-red items1">
      {{this.itemsCart.totalTax | currency }}
    </div>
  </div>
  <div class="alltotals-c items ">
    <div class="alltotals-txt items1">
      COSTO DE ENV&Iacute;O
    </div>
    <div class="alltotals-numb roboto-b items1">
      &#36;0.00
    </div>
  </div>
  <div class="alltotals-c items" *ngIf="this.itemsCart.totalDownPayment!=0">
    <div class="alltotals-txt items1">
      DOWNPAYMENT
    </div>
    <div class="alltotals-numb roboto-b f-red items1">
      {{this.itemsCart.totalDownPayment | currency }}
    </div>
  </div>
  <div class="alltotals-c items" *ngIf="this.itemsCart.depositAmount!=0">
    <div class="alltotals-txt items1">
      DEPÓSITO
    </div>
    <div class="alltotals-numb roboto-b f-red items1">
      {{this.itemsCart.depositAmount | currency }}
    </div>
  </div>

  <div class="alltotals-c items" *ngFor="let item of this.itemsCart.charges">
    <div class="alltotals-txt items1">
      {{item.charge | uppercase}}
    </div>
    <div class="alltotals-numb roboto-b f-red items1">
      {{item.price | currency }}
    </div>
  </div>
</div>
<div class="linetitle-b lessmb lessmt"></div>
<div class="basicrow paytotal">
  <div class="finaltotals-c txt-right roboto-b  finaltotals-d">
    TOTAL A PAGAR HOY<br />
    <span class="finaltotal-f f-red">{{this.itemsCart.totalPrice | currency}}</span>
  </div>
  <div class="finaltotals-c txt-right roboto-b finalrentdef">
    RENTA MENSUAL<br />
    <span class="finaltotal-f f-red">{{this.itemsCart.totalPerMonth | currency}}</span>
  </div>
</div>
<div class="basicrow no-print">
  <div class="content-text">
    <div class="internal-text">
      Renta mensual aproximada no incluye cargos estatales, federales, ni otros impuestos.
    </div>
  </div>
</div>
<div class="littlec-line"></div>
